import React, { useEffect, useRef, useState } from 'react';
import { api } from '../api';

export default function SheepSearch({ onSelect, placeholder = 'Search sheep ID...', status, limit = 8 }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const blurTimer = useRef(null);

  useEffect(() => {
    const value = query.trim();
    if (!value) {
      setResults([]);
      setLoading(false);
      setError('');
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError('');
    const timer = setTimeout(() => {
      api.searchSheep(value, { status, limit })
        .then(data => {
          if (!active) return;
          setResults(data);
          setOpen(true);
        })
        .catch(err => {
          if (!active) return;
          setError(err.message);
          setResults([]);
          setOpen(true);
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    }, 160);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [query, status, limit]);

  const choose = (sheep) => {
    setQuery('');
    setResults([]);
    setOpen(false);
    onSelect(sheep);
  };

  return (
    <div className="live-sheep-search">
      <input
        aria-label="Search sheep ID"
        value={query}
        onChange={e => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => query.trim() && setOpen(true)}
        onBlur={() => {
          blurTimer.current = setTimeout(() => setOpen(false), 120);
        }}
        placeholder={placeholder}
      />
      {open && query.trim() && (
        <div className="live-search-results" onMouseDown={() => clearTimeout(blurTimer.current)}>
          {loading && <div className="live-search-empty">Searching...</div>}
          {!loading && error && <div className="live-search-empty">{error}</div>}
          {!loading && !error && results.length === 0 && <div className="live-search-empty">No sheep found.</div>}
          {!loading && !error && results.map(sheep => (
            <button key={sheep.id} type="button" onClick={() => choose(sheep)}>
              <strong>{sheep.tag_id}</strong>
              <span>{sheep.sex} - {sheep.status}{sheep.breed ? ` - ${sheep.breed}` : ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
